exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".candidate-status{color:#eb0011!important;font-weight:400;font-size:.8667rem}", "", {"version":3,"sources":["/app/src/components/master/onboarding/ProviderCandidateDetail.vue"],"names":[],"mappings":"AACA,kBACE,wBAA0B,AAC1B,gBAAiB,AACjB,kBAAqB,CACtB","file":"ProviderCandidateDetail.vue","sourcesContent":["\n.candidate-status {\n  color: #eb0011 !important;\n  font-weight: 400;\n  font-size: 0.8667rem;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-adfc1a2c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/master/onboarding/ProviderCandidateDetail.vue
// module id = 882
// module chunks = 31